<template>
  <date-picker
    :lang="lang"
    :type="type"
    :value-type="valueType"
    :format="format"
    v-model="date"
    :confirm="confirm"
    :name="name"
    :placeholder="placeholder"
    :clearable="clearable"
    :disabled="disabled"
    :append-to-body="appendToBody"
    @change="$emit('change', date)"
  ></date-picker>
</template>

<script>
import Vue from "vue";
export default {
  computed: {
    date: {
      get() {
        // Filter out default 1970 dates if enabled
        if (this.filterDefaultDate && this.isDefaultDate(this.value)) {
          return null;
        }
        if (this.valueType != "format") {
          return this.value;
        } else if (this.type == "datetime") {
          return this.dateTimeFormat(this.value);
        } else {
          return this.dateFormat(this.value);
        }
      },
      set(val) {
        if (!val || this.isDefaultDate(val)) {
          this.$emit("input", this.epochValue());
          return;
        }

        if (this.valueType != "format") {
          this.$emit("input", val);
        } else {
          this.$emit("input", this.dateTimeFormat(val));
        }
      },
    },
  },
  methods: {
    isDefaultDate(date) {
      if (!date) return true;
      const dateStr = typeof date === 'string' ? date : new Date(date).toISOString();
      return dateStr.startsWith('1970-01-01') || dateStr.startsWith('1970-01-02');
    },
    epochValue() {
      if (this.valueType !== 'format') {
        return new Date(0);
      }

      const fmt = typeof this.format === 'string' ? this.format : (this.type === 'datetime' ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD');
      if (fmt.includes('HH') || this.type === 'datetime') {
        return '1970-01-01 00:00:00';
      }
      return '1970-01-01';
    },
  },
  props: {
    lang: {
      type: String,
      default: "en",
    },
    type: {
      type: String,
      default: "date",
    },
    valueType: {
      default: "format",
    },
    format: {
      type: [String, Object],
      default() {
        const map = {
          date: "YYYY-MM-DD",
          datetime: "YYYY-MM-DD HH:mm:ss",
          year: "YYYY",
          month: "YYYY-MM",
          time: "HH:mm:ss",
          week: "w",
        };
        return map[this.type] || map.date;
      },
    },
    confirm: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      required: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    appendToBody: {
      type: Boolean,
      default: true,
    },
    filterDefaultDate: {
      type: Boolean,
      default: true,
    },
    value: [String, Object, Date],
    placeholder: {
      type: String,
      required: false,
    },
  },
  created() {
    Vue.config.silent = true;
  },
};
</script>